import SignUpHeader from './Header';
import { ReactComponent as FinLogo } from 'assets/signup/finLogo.svg'

const Fourth = () => {
    return (
        <>
            <SignUpHeader title={'회원가입 완료'} idx={4} />
            <div className='flex flex-col justify-center items-center gap-10 py-30 mobile:py-4'>
                <FinLogo className='mobile:w-22 mobile:h-22' />
                <div className='mobile:text-base text-lg text-center'>
                    <p>PulseOnShip 회원 가입을 축하 드립니다.</p>
                    <p>원할한 서비스 이용을 위해 사업자 등록증을 첨부해 주시기 바랍니다</p>
                </div>
                <p className='text-primary mobile:text-sm'>마이페이지 → 회사정보 → 사업자 등록증 첨부</p>
            </div>
        </>
    )
}

export default Fourth